let version = ''
let envName = ''
let enableEmail = false
let enableDocument = false
let rootApi = null
let communityHowToId = null
let feedbackUrl = null
let intranetPresentationUrl = null
let atInternetScriptUrl = null
let commitId = null
let feedierUrl = null
let maintenanceMode = false
let maintenanceStartDate = null
let maintenanceEndDate = null
let pianoAnalyticsDomain = null
let pianoAnalyticsSiteIdDev = null
let pianoAnalyticsSiteIdProd = null

if (process.env) {
  rootApi = process.env.VUE_APP_ROOT_API
  enableEmail = process.env.VUE_APP_ENABLE_EMAIL === 'true'
  enableDocument = process.env.VUE_APP_ENABLE_DOCUMENT === 'true'
  version = process.env.VUE_APP_VERSION
  envName = process.env.VUE_APP_ENV_NAME
  communityHowToId = process.env.VUE_APP_COMMUNITY_HOW_TO_ID
  feedbackUrl = process.env.VUE_APP_FEEDBACK_URL
  intranetPresentationUrl = process.env.VUE_APP_INTRANET_PRESENTATION_URL
  atInternetScriptUrl = process.env.VUE_APP_AT_INTERNET_SCRIPT_URL
  commitId = process.env.VUE_APP_COMMIT_ID
  feedierUrl = process.env.VUE_APP_FEEDIER_URL
  maintenanceMode = process.env.VUE_APP_MAINTENANCE_MODE === 'true'
  maintenanceStartDate = process.env.VUE_APP_MAINTENANCE_START_DATE
  maintenanceEndDate = process.env.VUE_APP_MAINTENANCE_END_DATE
  pianoAnalyticsDomain = process.env.VUE_APP_PIANO_ANALYTICS_DOMAIN
  pianoAnalyticsSiteIdDev = process.env.VUE_APP_PIANO_ANALYTICS_SITE_ID_DEV
  pianoAnalyticsSiteIdProd = process.env.VUE_APP_PIANO_ANALYTICS_SITE_ID_PROD
}

const isBlank = str => (!str || /^\s*$/.test(str))

const getRootApi = () => {
  if (!isBlank(rootApi)) {
    return rootApi
  }
  if (window.location.hostname === 'localhost') {
    return 'http://localhost:8080'
  }
  return window.location.hostname.indexOf('front') !== -1
    ? `https://${window.location.hostname.replace('front', 'back')}`
    : `https://api.${window.location.hostname}`
}

export default {
  getRootApi: getRootApi,
  VERSION: version,
  ENV_NAME: envName,
  ENABLE_EMAIL: enableEmail,
  ENABLE_DOCUMENT: enableDocument,
  COMMUNITY_HOW_TO_ID: communityHowToId,
  FEEDBACK_URL: feedbackUrl,
  INTRANET_PRESENTATION_URL: intranetPresentationUrl,
  AT_INTERNET_SCRIPT_URL: atInternetScriptUrl,
  COMMIT_ID: commitId,
  FEEDIER_URL: feedierUrl,
  MAINTENANCE_MODE: maintenanceMode,
  MAINTENANCE_START_DATE: maintenanceStartDate,
  MAINTENANCE_END_DATE: maintenanceEndDate,
  PIANO_ANALYTICS_DOMAIN: pianoAnalyticsDomain,
  PIANO_ANALYTICS_SITE_ID_DEV: pianoAnalyticsSiteIdDev,
  PIANO_ANALYTICS_SITE_ID_PROD: pianoAnalyticsSiteIdProd
}
